/**
 * Associe une catégorie à une icône du jeu de l'application.
 *
 * Les catégories stockaient un emoji en base (`categorie.icon`). Ces emojis
 * changeaient de dessin selon le système d'exploitation et cassaient
 * l'homogénéité du reste de l'interface. On les remplace par une
 * correspondance sur le nom, qui fonctionne aussi pour les catégories créées
 * par l'utilisateur sans qu'il ait à choisir une icône.
 *
 * La donnée en base n'est pas touchée : seul l'affichage change.
 */

// Ordre significatif : la première entrée dont un mot-clé apparaît dans le nom
// de la catégorie gagne. Les termes les plus spécifiques viennent donc d'abord.
const RULES = [
  ['salaire|paie|paye|revenu|traitement|prime|virement reçu', 'briefcase'],
  ['loyer|logement|immobilier|maison|appartement|charges|copropri', 'home'],
  ['course|alimentation|alimentaire|supermarch|nourriture|epicerie|épicerie', 'cart'],
  ['restaurant|resto|bar|caf[ée]|midi|repas|traiteur', 'food'],
  ['transport|essence|carburant|voiture|auto|p[ée]age|parking|train|bus|metro|métro', 'car'],
  ['sant[ée]|m[ée]decin|pharmacie|mutuelle|dentiste|h[ôo]pital', 'heart'],
  ['cadeau|anniversaire|no[eë]l|don', 'gift'],
  ['[ée]lectricit|gaz|eau|[ée]nergie|facture|edf|abonnement', 'plug'],
  ['t[ée]l[ée]phone|mobile|internet|box|forfait|t[ée]l[ée]com', 'phone'],
  ['[ée]cole|[ée]tude|formation|livre|cours|scolarit|universit', 'book'],
  ['voyage|vacance|h[ôo]tel|avion|billet', 'plane'],
  ['[ée]pargne|placement|livret|investissement|pea|assurance vie', 'piggy'],
  ['banque|frais bancaire|agios|int[ée]r[êe]t|compte', 'bank'],
  ['virement|transfert|actualisation', 'swap'],
  ['loisir|sport|cin[ée]ma|abonnement|sortie|jeu', 'target'],
  ['achat|shopping|v[êe]tement|magasin', 'card'],
]

const COMPILED = RULES.map(([pattern, icon]) => [new RegExp(pattern, 'i'), icon])

/**
 * @param {string} categorie   nom de la catégorie
 * @param {'entrée'|string} type  sens de l'opération, utilisé en dernier recours
 * @returns {string} nom d'icône valide dans <Icon />
 */
export function categoryIcon(categorie, type) {
  const nom = (categorie || '').trim()
  if (nom) {
    const match = COMPILED.find(([re]) => re.test(nom))
    if (match) return match[1]
  }
  // Sans correspondance, le sens de l'opération reste l'information utile.
  return type === 'entrée' ? 'arrowDown' : 'arrowUp'
}

export default categoryIcon
